import { useLocalStorage } from "@medoma/shared-employee/useLocalStorage";
import { useAuth } from "react-oidc-context";
import { z } from "zod";

// Primitive theming for internal validation. There is no persistence beyond
// localStorage and no server sync — flipping the value applies live (the hook
// listens for storage events), so a UI control just calls `setTheme`.
// The `white` theme is the base palette defined in styles/_colors.scss;
// `warm` overrides it and is what users get until they pick something else.
export const themeSchema = z.enum(["white", "warm"]);

export const useTheme = () => {
  // ThemeHelmet renders above the auth guard, so the sign-in screen has no
  // employee to read a theme for and shows the warm palette.
  const { user } = useAuth();

  const [stored, setTheme] = useLocalStorage({
    key: "colorTheme",
    userId: user?.profile.sub,
    initialValue: themeSchema.enum.warm,
  });
  const parsed = themeSchema.safeParse(stored);
  const theme = parsed.success ? parsed.data : themeSchema.enum.warm;
  return [theme, setTheme] as const;
};
